import { FC } from 'react';

import {
  BodyTypography,
  FontSizeEnum,
  FontWeightEnum,
  Heading,
  HeadingEnum,
} from '@argenta/react-ui';
import { t, Trans } from '@lingui/macro';

import { ImageWithFallback } from '../../components/ImageWithFallback';
import { useToggles } from '../../hooks/useToggles';

import './ApplicationConfirmation.styles.scss';

export const ApplicationConfirmation: FC = () => {
  const {
    ops: { applicationConfirmationImage },
  } = useToggles();

  return (
    <div className="argnt-application-confirmation">
      <div className="argnt-application-confirmation__container">
        <Heading type={HeadingEnum.H2} fontWeight={FontWeightEnum.BOLD}>
          <Trans id="vacancies.application.confirmation.title" />
        </Heading>
        <BodyTypography
          fontSize={FontSizeEnum.MEDIUM}
          fontWeight={FontWeightEnum.REGULAR}
          isParagraph
        >
          <Trans id="vacancies.application.confirmation.paragraph" />
        </BodyTypography>
        <ImageWithFallback
          className="argnt-application-confirmation__image"
          alt={t({ id: 'vacancies.application.confirmation.image' })}
          fallbackImageSource={`${process.env.PUBLIC_URL}/assets/images/application_confirmation.jpg`}
          imageSource={applicationConfirmationImage}
        />
      </div>
    </div>
  );
};
